import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type {ItemEffectsObject} from '@PosterWhiteboard/classes/item-effects.class';

export function useGetKeyFromEffectsActiveItem<T extends keyof ItemEffectsObject>(key: T): ItemEffectsObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];

    if (item && 'effects' in item && item.effects[key] !== undefined) {
      return item.effects[key];
    }

    return undefined;
  });
}
